import { format } from 'date-fns';

export const convertYesNoToBoolean = (value) => {
  if (value === 'yes') return true;
  if (value === 'no') return false;
  return false;
};

export const mapBackendToForm = (data) => {
  if (!data) return {};

  const mappedData = { ...data };

  // Format dates
  const dateFields = ["date_time_of_surgery"];
  dateFields.forEach(field => {
    if (mappedData[field]) {
      mappedData[field] = new Date(mappedData[field]).toISOString().slice(0, 16);
    }
  });

  // Convert boolean to "yes"/"no" for radio-like checkboxes
  mappedData.adequate_iv_fluids_planned = mappedData.adequate_iv_fluids_planned ? "yes" : "no";
  mappedData.adequate_iv_fluids_administered = mappedData.adequate_iv_fluids_administered ? "yes" : "no";
  mappedData.risk_of_500ml_blood_loss = mappedData.risk_of_500ml_blood_loss ? "yes" : "no";
  mappedData.difficult_airway_assistance_available = mappedData.difficult_airway_assistance_available ? "yes" : "no";
  mappedData.instrument_sponge_needle_count_checked = mappedData.instrument_sponge_needle_count_checked ? "yes" : "no";
  mappedData.essential_imaging_displayed = mappedData.essential_imaging_displayed ? "yes" : "no";
  mappedData.antibiotic_prophylaxis = mappedData.antibiotic_prophylaxis ? "yes" : "no";
  mappedData.known_allergy = mappedData.known_allergy ? "yes" : "no";
  mappedData.site_marked = mappedData.site_marked ? "yes" : "no";

  return mappedData;
};

export const formatDateForSubmit = (date) => {
    if (!date) return '';
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) {
        console.error("Invalid date:", date);
        return '';
    }
    return format(parsedDate, 'yyyy-MM-dd HH:mm:ss');
};

export const mapFormToBackend = (formData) => {
  return {
    identity_confirmed: formData.identity_confirmed,
    site_confirmed: formData.site_confirmed,
    procedure_confirmed: formData.procedure_confirmed,
    consent_confirmed: formData.consent_confirmed,
    site_marked: convertYesNoToBoolean(formData.site_marked),
    anesthesia_safety_check: formData.anesthesia_safety_check,
    pulse_oximeter_functioning: formData.pulse_oximeter_functioning,
    known_allergy: convertYesNoToBoolean(formData.known_allergy),
    difficult_airway: formData.difficult_airway,
    difficult_airway_assistance_available: convertYesNoToBoolean(formData.difficult_airway_assistance_available),
    risk_of_500ml_blood_loss: convertYesNoToBoolean(formData.risk_of_500ml_blood_loss),
    adequate_iv_fluids_planned: convertYesNoToBoolean(formData.adequate_iv_fluids_planned),
    blood_standby: formData.blood_standby,
    serology_status_negative: formData.serology_status_negative,
    serology_status_positive: formData.serology_status_positive,
    ot_nurse_name: formData.ot_nurse_name,
    ot_nurse_signature: formData.ot_nurse_signature,
    team_introduction: formData.team_introduction,
    patient_confirmation: formData.patient_confirmation,
    site_confirmation: formData.site_confirmation,
    procedure_confirmation: formData.procedure_confirmation,
    anticipated_critical_event: formData.anticipated_critical_event,
    anesthesia_team_review: formData.anesthesia_team_review,
    nursing_team_review: formData.nursing_team_review,
    antibiotic_prophylaxis: convertYesNoToBoolean(formData.antibiotic_prophylaxis),
    essential_imaging_displayed: convertYesNoToBoolean(formData.essential_imaging_displayed),
    anesthesiologist_name: formData.anesthesiologist_name,
    anesthesiologist_signature: formData.anesthesiologist_signature,
    nurse_verbal_confirmation: formData.nurse_verbal_confirmation,
    procedure_recorded: formData.procedure_recorded,
    instrument_sponge_needle_count_checked: convertYesNoToBoolean(formData.instrument_sponge_needle_count_checked),
    specimen_labelled: formData.specimen_labelled,
    equipment_problem: formData.equipment_problem,
    recovery_concerns: formData.recovery_concerns,
    post_op_instruction_by_surgeon: formData.post_op_instruction_by_surgeon,
    post_op_instruction_by_anesthesiologist: formData.post_op_instruction_by_anesthesiologist,
    recovery_charting_done: formData.recovery_charting_done,
    surgeon_name: formData.surgeon_name,
    surgeon_signature: formData.surgeon_signature,
    uhid_no: formData.uhid_no,
    ip_no: formData.ip_no,
    ward_room_no: formData.ward_room_no,
    procedure_name: formData.procedure_name,
    primary_consultant: formData.primary_consultant,
    date_time_of_surgery: formatDateForSubmit(formData.date_time_of_surgery),
  };
};
